import { useState } from "react";
import { Facebook, Send, Link2, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../i18n";

export default function ShareButtons({ title }) {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = `${title} — KATACO`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(t("share.copied"));
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      /* clipboard unavailable */
    }
  };

  const btn =
    "flex items-center gap-2 text-xs font-semibold border border-white/15 text-slate-300 rounded-full px-4 py-2.5 hover:border-[rgba(68,153,247,0.6)] hover:text-[#4499F7] transition-colors";

  return (
    <div className="mt-5 flex flex-wrap items-center gap-3" data-testid="share-buttons">
      <span className="text-[11px] font-mono-num tracking-widest uppercase text-slate-500">{t("share.label")}</span>
      <a
        data-testid="share-facebook"
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
        aria-label="Share on Facebook"
      >
        <Facebook size={14} /> Facebook
      </a>
      <a
        data-testid="share-whatsapp"
        href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
        aria-label="Share on WhatsApp"
      >
        <Send size={14} /> WhatsApp
      </a>
      <button data-testid="share-copy" onClick={copy} className={btn}>
        {copied ? <Check size={14} /> : <Link2 size={14} />}
        {t("share.copy")}
      </button>
    </div>
  );
}
